import { render, staticRenderFns } from "./featureAdd.vue?vue&type=template&id=3daea3c8"
import script from "./featureAdd.vue?vue&type=script&lang=js"
export * from "./featureAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports